import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Table, Tabs } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import { defaultAvatarImg, idQuyDauTu, searchLength } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, tabNameDSHopDong } from '../../helpers/common';
import { ChiTietHopDongResponse, HopDong } from '../../models/hopdong/HopDong';
import { NhanVienResponse, TimKiemNhanVienPagingResponse, TimKiemNhanVienHopDongRequest } from '../../models/nhanvien/NhanVien';
import { layDsHopDongTheoIdNhanVien, timKiemDSNhanVienHopDong } from '../../services/hopdong';
import DanhSachHopDongBox from './DanhSachHopDongBox';
import LoaiHopDongTree from '@app/modules/danhmuc/LoaiHopDongTree';

const DanhSachHopDongTheoNV = () => {
    const [loadingHD, setLoadingHD] = useState<boolean>(false);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.HopDong.ChiTiet]);
    const [hopDongActive, setHopDongActive] = useState<HopDong>(new HopDong);
    const [nhanVienInfo, setNhanVienInfo] = useState<NhanVienResponse | null>(null);
    const [dsHopDongKhac, setDsHopDongKhac] = useState<Array<HopDong>>([]);
    const [idLoaiHopDong, setIdLoaiHopDong] = useState<number>(0);    
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [danhsach, setDanhSach] = useState<TimKiemNhanVienPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const timkiem = async (idLoaiHopDong: number, tuKhoa: string, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            var rq = new TimKiemNhanVienHopDongRequest;
            rq.idLoaiHopDong = idLoaiHopDong;
            rq.tuKhoa = tuKhoa;
            const temp = await timKiemDSNhanVienHopDong(rq, start, length);
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": 0,
                "pageCurrent": page,
                "pageListShow": []
            });
        }
        catch (error: any) {
        };

        setIsLoadingTable(false);
    }

    const layDsHopDong = async (idNV: number) => {
        try {
            if (idNV > 0) {
                setLoadingHD(true);
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                setNhanVienInfo(rs.nhanVienInfo);
                var hdActive = rs?.dsHopDong?.find(item => item.trangThai === 1);
                var hsAnother = rs?.dsHopDong?.filter(item => item.trangThai === 0);
                setHopDongActive(hdActive as HopDong);
                setDsHopDongKhac(hsAnother);
                setLoadingHD(false);
            }
        }
        catch (error: any) {
            setLoadingHD(false);
        }
    };

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdLoaiHopDong(e.id);
            timkiem(e.id, tuKhoa, 0, 0, 0);
        } else {
            setIdLoaiHopDong(0);
            timkiem(0, tuKhoa, 0, 0, 0);
        }
    };

    const containerLoaiHopDongProps = {
        showHeader: false,
        onChange: onChangeDepartment,
    }

    useEffect(() => {
        timkiem(idLoaiHopDong, tuKhoa, 0, 0, 0);
    }, []);

    useEffect(() => {
        if (nhanVienInfo) {
            const element = document.getElementById("detail-nhan-vien");
            element?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [nhanVienInfo]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idLoaiHopDong, tuKhoa, 0, 0, 0)
        }
    };
    return (
        <section>
            <ContentHeader title="Quản lý hợp đồng/QĐ bổ nhiệm" />
            <Row className="form-group" gutter={8}>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, email, số điện thoại, loại hợp đồng" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={8}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(idLoaiHopDong, tuKhoa, 0, searchLength, 0)}>
                            Tìm kiếm
                        </Button>{/*
                        <Button className="hrm-btn hrm-btn-success" icon={<DownloadOutlined rev="" />}>
                            Xuất excel
                        </Button>*/}
                    </Space>
                </Col>
            </Row>
            <Row gutter={8}>
                <Col span="6">
                    <LoaiHopDongTree {...containerLoaiHopDongProps} />
                </Col>
                <Col span="18">
                    <div className="card card-primary">
                        <Row>
                            <Col span={24}>
                                <Table
                                    loading={isLoadingTable}
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={(danhsach.data || []).map((value, index) => { const item = { key: value.id, ...value }; return item; })}
                                    onRow={(record, rowIndex) => {
                                        return {
                                            onClick: event => {
                                                if (record?.id === nhanVienInfo?.id) {
                                                    setNhanVienInfo(null);
                                                } else {
                                                    setNhanVienInfo(record);
                                                    layDsHopDong(record.id);
                                                }
                                            },
                                        };
                                    }}
                                    pagination={{
                                        current: page, 
                                        onChange: (page, pageSize) => {
                                            setPage(page);
                                        },
                                    }}
                                    rowClassName={(record, index) => {
                                        return (record?.id === nhanVienInfo?.id) ? "selected-row row-key-" : "";
                                    }}
                                >
                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <span key={"stt" + index}>
                                                {(page - 1) * searchLength + index + 1}
                                            </span>
                                        )
                                        }
                                    />
                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                    <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                    <Column title="Loại hợp đồng/QĐ bổ nhiệm" dataIndex="loaiHopDong" key="loaiHopDong" />
                                    <Column title="Ngày bắt đầu"
                                        key="ngayBatDau"
                                        render={(value: any, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value.ngayBatDau)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Ngày kết thúc"
                                        key="ngayBatDau"
                                        render={(value: any, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value.ngayKetThuc)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title=""
                                        key="action"
                                        render={(value, record, index) =>
                                        (
                                            <Link to={Links.HopDong.Xem + "?id=" + value?.id} className="hrm-btn hrm-btn-sm float-right btn-primary" title="Chi tiết">Xem</Link>
                                        )
                                        }
                                    />
                                </Table>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <Row gutter={8} id="detail-nhan-vien" style={{ display: nhanVienInfo !== null ? "block" : "none" }}>
                <Col span={24}>
                    <div className="hrm-preview-footer">
                        <div>
                            <Tabs defaultActiveKey="1" 
                            tabBarExtraContent={menu[Links.HopDong.ChiTiet] ?
                                <Link className="hrm-btn float-right hrm-btn-warning" to={Links.HopDong.Xem + "?id=" + nhanVienInfo?.id}><PlusOutlined rev="" />Thêm mới</Link>
                                : null
                            } 
                            items={[
                                {
                                    key: '1',
                                    label: tabNameDSHopDong.thongTinHopDong,
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content">
                                                <Row>
                                                    <Col span={6}>
                                                        <div className="text-center mb-3">
                                                            <img className="profile-user-img img-fluid img-circle"
                                                                /*src={(nhanVienInfo?.avatar == null || nhanVienInfo?.avatar == "") ? defaultAvatarImg : nhanVienInfo?.avatar.replace("View\\public", "").replace(/\\/g, "/")}*/
                                                                src={(nhanVienInfo?.avatar == null || nhanVienInfo?.avatar == "") ? defaultAvatarImg : `/${nhanVienInfo?.avatar.replace(/\\/g, "/")}`}
                                                                alt="User profile picture" />
                                                        </div>
                                                        <div className="text-center">
                                                            <label className="mb-1">
                                                                <Link className="mb-1" to={Links.HopDong.Xem + "?id=" + nhanVienInfo?.id}>{nhanVienInfo?.hoTen?.toUpperCase()}</Link>
                                                            </label>
                                                        </div>
                                                        <div className="text-center"><label className="mb-1">{nhanVienInfo?.ma?.toUpperCase()}</label></div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <div className="mb-1">
                                                            <div>Chức vụ</div>
                                                            <label>{nhanVienInfo?.tenChucVu}</label>
                                                        </div>
                                                        <div className="mb-1">
                                                            <div>Phòng ban</div>
                                                            <label>{nhanVienInfo?.tenDonVi}</label>
                                                        </div>
                                                        <div>
                                                            <div>Email</div>
                                                            <label>{nhanVienInfo?.email}</label>
                                                        </div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <div className="mb-1">
                                                            <div>Số hợp đồng/QĐ bổ nhiệm</div>
                                                            <label>{hopDongActive?.soHopDong}</label>
                                                        </div>
                                                        <div className="mb-1">
                                                            <div>Từ ngày</div>
                                                            <label>{dateCommon.formatDate(hopDongActive?.ngayBatDau)}</label>
                                                        </div><div>
                                                            <div>Ngày ký hợp đồng</div>
                                                            <label>{dateCommon.formatDate(hopDongActive?.ngayKy)}</label>
                                                        </div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <div className="mb-1">
                                                            <div>Loại hợp đồng/QĐ bổ nhiệm</div>
                                                            <label>{hopDongActive?.loaiHopDong}</label>
                                                        </div>
                                                        <div className="mb-1">
                                                            <div>Đến ngày</div>
                                                            <label>{dateCommon.formatDate(hopDongActive?.ngayKetThuc)}</label>
                                                        </div>
                                                        <div className="mb-1">
                                                            <div>Nơi ký</div>
                                                            <label>{hopDongActive?.noiKy}</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                },
                                {
                                    key: '2',
                                    label: tabNameDSHopDong.hopDongKhac,
                                    children:
                                        <div className="card">
                                            <DanhSachHopDongBox listData={dsHopDongKhac} hopDongInfo={new ChiTietHopDongResponse} onSubmit={() => { } } idNhanVien={nhanVienInfo?.id || 0} />
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachHopDongTheoNV;
